import { render, staticRenderFns } from "./BlogPosts.vue?vue&type=template&id=4d7654de&scoped=true&"
import script from "./BlogPosts.vue?vue&type=script&lang=js&"
export * from "./BlogPosts.vue?vue&type=script&lang=js&"
import style0 from "./BlogPosts.vue?vue&type=style&index=0&id=4d7654de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d7654de",
  null
  
)

export default component.exports